import { DashboardCard, Http } from '../../../models/index';
import { SaveAttributesResource } from './SaveAttributesResource';

export class SaveDashboardCard extends SaveAttributesResource<DashboardCard> {
    /* istanbul ignore next */
    constructor(http: Http) {
        super(http);
    }
}
